/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { string, node } from 'prop-types'
import './Header.css'
import { useFetch } from '../utils/hooks'

const AMPLOGO = window.AMPMSSITEPATH + 'images/shared/amp-site-logo-sm.png'
const AMPLOGOSM = window.AMPMSSITEPATH + 'images/shared/SOLID_WHITE_LOGO_SMALL.png'
const BACKGROUND = 'u-bgColorBrand'
const BACKGROUNDCONTRAST = 'Content--reversed'

/*
 * <MicrositeHeader />
 * Renders the site header
 */

export const MicrositeHeader = props => {
  let largeSizeImage = AMPLOGO
  if (props && props.imageLarge) {
    largeSizeImage = props.imageLarge
  }

  let smallSizeImage = AMPLOGOSM
  if (props && props.imageSmall) {
    smallSizeImage = props.imageSmall
  }

  let background = BACKGROUND
  if (props && props.backgroundColor) {
    background = props.backgroundColor
  }

  let backgroundContrast = BACKGROUNDCONTRAST
  if (props && props.backgroundContrast) {
    backgroundContrast = props.backgroundContrast
  }

  let apiUrl = ''
  if (props && props.contentIdentifier) {
    apiUrl = `http://localhost:8081/site/ampmicrosites/halapi/documents/${props.contentIdentifier}`
  }

  const { status, data, error } = useFetch(apiUrl)
  const navItems = data.utilityNavigation
  //TO DO: Get logos from API. If no logos from CMS then use default logos.
  //const deskTopLogo = data.desktopLogo && data.desktopLogo.image._meta.mirror.path

  const headerClasses = 'PageHeader amp-header ' + background + ' ' + backgroundContrast

  const [popover, isPopoverVisible] = useState(false)

  useEffect(() => {
    if (popover) {
      document.body.classList.add('no-scroll')
    } else {
      document.body.classList.remove('no-scroll')
    }
  }, [popover])

  const isLightContrast = backgroundContrast === 'light'

  return (
    <>
      <div className={headerClasses}>
        <div className='u-sizeConstrained'>
          <div className='u-flex u-flexRow u-flexJustifyBetween'>
            <button className='u-md-hidden u-lg-hidden amp-hamburger'>
              <div className='u-flex u-flexCol u-flexJustifyCenter u-flexAlignItemsCenter'>
                <div className='amp-hamburger-icon' onClick={() => isPopoverVisible(!popover)}>
                  <div aria-hidden='true' className='u-textColorWhite'>
                    <div
                      className={`amp-hamburger-icon-dash ${
                        isLightContrast ? 'u-bgColorActionBlue' : 'u-bgColorWhite'
                      } u-marginTop4 u-marginBottom4`}>
                      &nbsp;
                    </div>
                    <div
                      className={`amp-hamburger-icon-dash ${
                        isLightContrast ? 'u-bgColorActionBlue' : 'u-bgColorWhite'
                      } u-marginTop4 u-marginBottom4`}>
                      &nbsp;
                    </div>
                    <div
                      className={`amp-hamburger-icon-dash ${
                        isLightContrast ? 'u-bgColorActionBlue' : 'u-bgColorWhite'
                      } u-marginTop4 u-marginBottom4`}>
                      &nbsp;
                    </div>
                  </div>
                  <span className='u-hiddenVisually'>Menu</span>
                </div>
                <div
                  className={`amp-hamburger-icon-label ${
                    isLightContrast ? 'u-textColorActionBlue' : 'u-textColorWhite'
                  }`}
                  data-qa='HamburgerMenu'>
                  Menu
                </div>
              </div>
            </button>
            <div className='u-flex u-sm-flexAlignSelfCenter amp-siteLogo'>
              <a href='/'>
                <img
                  src={largeSizeImage}
                  alt='Ameriprise Financial'
                  className='u-sm-hidden u-md-hidden'></img>
                <img src={smallSizeImage} alt='Ameriprise Financial' className='u-lg-hidden'></img>
              </a>
            </div>
            <div className='PageHeader-buttonWrap u-sm-hidden u-md-flexRow u-lg-flexRow u-sm-marginTop20'>
              {status === 'error' && <div>{error}</div>}
              {status === 'fetching' && <div className='loading'></div>}
              {status === 'fetched' && (
                <>
                  {navItems &&
                    navItems.map((item, index, navItems) => (
                      <div className='ms-listItem u-marginVert16' key={`menu-item-${index}`}>
                        <p>
                          <a
                            className='Link Link--currentColor u-padding4'
                            target='_blank'
                            rel='noopener noreferrer'>
                            {item.text}
                          </a>
                          {!(index + 1 === navItems.length) && (
                            <span
                              className='u-textColorWhite u-marginHoriz8'
                              key={`menu-item-pipe-${index}`}>
                              |
                            </span>
                          )}
                        </p>
                      </div>
                    ))}
                </>
              )}

              {(data === undefined || data.length === 0) && (
                <>
                  <a
                    href='/privacy-security-fraud/online-security-guarantee'
                    className={`Link ${
                      isLightContrast ? '' : 'Link--reversed'
                    } u-flex u-flexAlignItemsCenter`}>
                    <i
                      className={`Icon icon-shield m-header-icon ${
                        isLightContrast ? 'u-textColorActionBlue' : 'u-textColorWhite'
                      } u-posRelative`}
                      aria-hidden
                    />{' '}
                    Online security guarantee
                  </a>
                  <span
                    className={`pipe--Divider ${
                      isLightContrast ? '' : 'u-textColorWhite'
                    } u-posRelative u-marginHoriz8`}>
                    |
                  </span>
                  <a
                    href='/customer-service'
                    className={`Link ${isLightContrast ? '' : 'Link--reversed'}`}>
                    Customer service
                  </a>
                </>
              )}

              {props.component && props.component === 'welcome' && (
                <a
                  href='#registrationForm'
                  className='Button Button--small Button--primary Button--reversed u-marginLeft20'
                  aria-label={'Set up your online access'}>
                  Set up your online access
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      {popover && (
        <div className='amp-nav u-borderVert u-borderColorNeutral u-borderTop0'>
          <div className='u-sizeConstrained amp-nav-inner u-flex Popover amp-nav-level-one is-visible'>
            <nav className='u-flex u-flexAlignItemsStretch amp-nav-level-one'>
              <ul
                className='List List--selectable amp-mainNav u-flexJustifyStart u-borderBottom0'
                aria-label='menu'
                data-qa='MainNavLevelOne'>
                <li className='List-item amp-mainNav-item amp-mainNav-item u-lg-hidden'>
                  <a
                    className='amp-mainNav-link'
                    href='/privacy-security-fraud/online-security-guarantee'
                    data-analytics='Online security guarantee'>
                    Online security guarantee
                  </a>
                </li>
                <li className='List-item amp-mainNav-item amp-mainNav-item u-lg-hidden'>
                  <a
                    className='amp-mainNav-link'
                    href='/customer-service'
                    data-analytics='Customer Service'>
                    Customer Service
                  </a>
                </li>
                {props.component && props.component === 'welcome' && (
                  <li className='List-item amp-mainNav-item amp-mainNav-item u-lg-hidden'>
                    <a
                      href='#registrationForm'
                      className='amp-mainNav-link'
                      aria-label='Set up your online access'>
                      Set up your online access
                    </a>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      )}
    </>
  )
}

MicrositeHeader.propTypes = {
  className: string,
  children: node,
  contentIdentifier: string,
  imageLarge: string,
  imageSmall: string,
  backgroundColor: string,
  backgroundContrast: string,
  component: string,
}

MicrositeHeader.defaultProps = {
  children: null,
  className: '',
  contentIdentifier: '',
  imageLarge: '',
  imageSmall: '',
  backgroundColor: '',
  backgroundContrast: '',
  component: '',
}
